module.exports = __webpack_public_path__ + "img/cases.17b3a3fa.png";